import { Typography } from "@mui/material";
import { Stack } from "@mui/system";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { logEvent, logPageView } from "../../analytics";
import ImageAssets from "../../assets";
import { MuiButton } from "../../components/common/button/MuiButton";
import SimpleSlider from "../../components/common/simple-slider/SimpleSlider";
import { carouselJson } from "../../core/json/CarouselJson";
import routesNames from "../../routes/RouteNames";
import strings from "../../strings/Strings";
import styles from "./Landing.module.css";

const MobileLandingPage = () => {

  useEffect(() => {
    logPageView("Mobile Landing", "Mobile Landing");
  }, []);

  const handleBtnClick = (btnType: string) => {
    logEvent('User Interaction', btnType, btnType);
  }

  const navigate = useNavigate();
  return (
    <div className={styles["main-container"]}>
      <header className={styles["sekeron-icon-header"]}>
        <img
          alt="logo"
          src={ImageAssets.ic_sekeron}
          className={styles["sekeron-icon-header-image-mobile"]}
        />
      </header>
      <div className={styles["section-container"]}>
        <div className={styles["slider-container"]}>
          <SimpleSlider
            isAutoplay={true}
            carouselImages={carouselJson}
            isLanding={true}
          />
        </div>
      </div>
      <div className={styles["footer-container"]}>
        <MuiButton
          className={styles["continue_btn"]}
          onClick={() => {
            navigate("/registration")
            handleBtnClick(" Mobile Landing - Join for Free");
          }}
        >
          Join for Free
        </MuiButton>

        <Typography
          className={styles["joined-already"]}
        //   onClick={() => navigate(routesNames.login)}
        >
          Have an account?
          <Link to={routesNames.login} className={styles["login-link"]} onClick={() => handleBtnClick(`Mobile Landing ${strings.signIN} `)}>
            {strings.signIN}
          </Link>
        </Typography>
      </div>
    </div>
  );
};
export default MobileLandingPage;
